import {NativeDateAdapter} from '@angular/material';
import {Injectable} from '@angular/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/form-fields/datepicker-field/custom-date-adapter.ts